import { Helmet } from "react-helmet-async"
import { ISupplier, SupplierBookings } from "../../../../../Supplier"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../../Auth"
import { useOutletContext } from "react-router"

export default function CabSchedulesBookingsPage() {
	const { transportServiceProvider } = useOutletContext<{
		transportServiceProvider: ISupplier
		revalidate: () => void
	}>()
	return (
		<ForbidUnlessAuthorized
			permission={PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS}
		>
			<Helmet>
				<title>Cab Schedules Bookings | Supplier</title>
			</Helmet>
			<SupplierBookings transportServiceProvider={transportServiceProvider} />
		</ForbidUnlessAuthorized>
	)
}
